import { useState, useEffect } from 'react';

import Image from 'next/image';

import AirportAutoComplate, {
  AirPortTypes,
} from '@domain/flight/searchBar/airportAutoComplate';
import { FlightSearchBarActionType } from '@domain/flight/context/flight/actions';

import { StyledButton, Wrapper, StyledContent } from './styled';
import useFlightSearchBar from '../../context/flight';

type AirportDataTypes = {
  departure: AirPortTypes;
  arrival: AirPortTypes;
};

const AirportSelection = () => {
  const [isDepartureError, setIsDepartureError] = useState(false);
  const [isArrivalError, setIsArrivalError] = useState(false);
  const [isValueChange, setIsValueChange] = useState(0);

  const { state, dispatch } = useFlightSearchBar();

  const [data, setData] = useState<AirportDataTypes>({
    departure: null,
    arrival: null,
  });

  const handleChange = (type: string, value: AirPortTypes) => {
    setData((p) => ({ ...p, [type]: value }));
  };

  useEffect(() => {
    if (state.isSubmit) {
      handleValidation();
    }
  }, [state.isSubmit]);

  const handleValidation = () => {
    if (data.departure) {
      dispatch({
        type: FlightSearchBarActionType.SET_ARRIVAL_AIRPORT,
        payload: data.arrival || null,
      });
      setIsDepartureError(false);
    } else {
      setIsDepartureError(true);
    }
    if (data.arrival) {
      dispatch({
        type: FlightSearchBarActionType.SET_DEPARTURE_AIRPORT,
        payload: data.departure || null,
      });
      setIsArrivalError(false);
    } else {
      setIsArrivalError(true);
    }

    if (data.arrival && data.departure) {
      dispatch({
        type: FlightSearchBarActionType.SET_IS_VALID_FLIGHT_SEARCH_BAR,
        payload: true,
      });
    }
    dispatch({
      type: FlightSearchBarActionType.SET_IS_SUBMIT,
      payload: false,
    });
  };

  const handleChangeValues = () => {
    setIsValueChange((prev) => prev + 1);
  };

  return (
    <StyledContent data-testid='airport-selection-container'>
      <Wrapper>
        <AirportAutoComplate
          label='Nereden'
          onChange={(airport) => handleChange('departure', airport)}
          error={isDepartureError}
          isValueChange={isValueChange}
          changedValue={data.arrival}
        />
      </Wrapper>
      <StyledButton onClick={handleChangeValues}>
        <Image
          src='/static/images/compareArrow.svg'
          width={17}
          height={19}
          alt='img'
        />
      </StyledButton>
      <Wrapper>
        <AirportAutoComplate
          label='Nereye'
          onChange={(airport) => handleChange('arrival', airport)}
          error={isArrivalError}
          isValueChange={isValueChange}
          changedValue={data.departure}
        />
      </Wrapper>
    </StyledContent>
  );
};
export default AirportSelection;
